import GeneralTab from './GeneralTab'
import './GeneralTab.css'

export default GeneralTab